import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { DailyStagingPayRoutingModule } from "@inventory/components/daily-staging-pay";
import { dailyStagingDeclarationComponents } from './daily-staging-pay-routing.module';
import { NgxPrintModule } from 'ngx-print';
import { BarcodePrinterModule } from '../barcode-printer/barcode-printer/barcode-printer.module';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
@NgModule({
    declarations: [ ...dailyStagingDeclarationComponents],
    imports: [
        CommonModule,
        DailyStagingPayRoutingModule,
        LayoutModule,
        SharedModule,
        NgxBarcode6Module,
        NgxPrintModule,
        BarcodePrinterModule,
        MatFormFieldModule,
        MatTabsModule
    ],
    entryComponents: [
        // StockCodeInfoPopupComponent, PurchaseOrderBarcodeModalComponent, PurchaseOrderTechnicianDeletePopupComponent
    ]
})

export class DailyStagingPayModule { }
